import type { PlayerStatsScope } from "../../../models/PlayerStats";

/**
 * The season a league's table opens on: the newest one with at least half the previous season's qualified population
 * (`populationN`, players past the roll-up's playtime floor), so the first weeks of a new season, a few dozen players
 * and no percentiles, don't greet everyone (Trevor, 2026-10-20). For the NBA that is ~245 players with 200+
 * possessions, about ten days in. The new season stays a click away. Mirrors the backend's
 * app/api/player_stats/service.default_season, which warms the same table.
 */
export function defaultSeason(scopes: PlayerStatsScope[], league: string | null): number | null {
  const own = scopes
    .filter((s) => s.league === league)
    .sort((a, b) => b.season - a.season);
  for (let i = 0; i < own.length; i++) {
    const prev = own[i + 1];
    if (!prev || (own[i].populationN ?? 0) >= 0.5 * (prev.populationN ?? 0)) return own[i].season;
  }
  return own[0]?.season ?? null;
}
